var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDownwardIconRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVG"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.5592 2.19336H2.44672C2.19184 2.19516 1.94189 2.26379 1.72183 2.3924C1.50176 2.52101 1.31929 2.70511 1.19263 2.9263C1.06597 3.14749 0.999547 3.39804 1 3.65292C1.00046 3.90781 1.06777 4.15812 1.19522 4.37886L5.25322 11.1534C5.38304 11.3677 5.56589 11.545 5.78414 11.6681C6.0024 11.7912 6.24869 11.856 6.49927 11.8563C6.74985 11.8565 6.99627 11.7922 7.21477 11.6695C7.43327 11.5468 7.61647 11.3699 7.74672 11.1559L11.8017 4.38636C11.9307 4.16605 11.9995 3.91573 12.0013 3.66046C12.0031 3.40518 11.9378 3.15392 11.8119 2.93184C11.686 2.70975 11.504 2.52464 11.284 2.39503C11.0641 2.26543 10.8145 2.19588 10.5592 2.19336Z",
    fill: "#FD1D1D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownwardIconRed);
export default __webpack_public_path__ + "static/media/ArrowDownwardIcon_red.52b03e750ce2f311cb69074b81b58327.svg";
export { ForwardRef as ReactComponent };